import './claudineartisankitchen/style';
import FormStructure from './claudineartisankitchen/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js